import { useParish } from "../lib/parishContext";
import { resolveApiUrl } from "../lib/url";
import SacristyLogo from "./SacristyLogo";

// Volunteer-facing brand mark: the parish's own uploaded logo when
// set (Settings → parish branding — existing feature, R2-backed
// upload in worker/src/routes/parish.ts; nothing new to build there),
// falling back to the Sacristy AI wordmark when the parish hasn't
// uploaded one. Admin/scheduler surfaces always show the Sacristy
// wordmark regardless of parish (SacristyTheme's own identity) — this
// conditional is volunteer-only, per the branding sprint's spec.
export default function VolunteerBrandMark({ height = 44 }: { height?: number }) {
  const { parish } = useParish();
  const logoSrc = resolveApiUrl(parish.logo_url);
  if (logoSrc) {
    return (
      <img
        className="volunteer-brand-mark"
        src={logoSrc}
        alt={`${parish.display_name} logo`}
        style={{ height, width: "auto" }}
      />
    );
  }
  return <SacristyLogo />;
}
